import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import {
  getAllDepartments,
  getAllPersons,
  getAllShops,
  getShoppingList,
} from "../api";

export const queryKeys = {
  food: (id: number) => ["food", id] as const,
  purchase: (id: number) => ["purchase", id] as const,
  shops: ["shops"] as const,
  departments: ["departments"] as const,
  persons: (inactive: boolean) => ["persons", inactive] as const,
  shoppingList: ["shoppingList"] as const,
};

// --- Suspense-Hooks (laden on-demand beim ersten Verwenden) -------------------

export const useShops = () =>
  useSuspenseQuery({
    queryKey: queryKeys.shops,
    queryFn: async () => (await getAllShops()).data,
  }).data;

export const useDepartments = () =>
  useSuspenseQuery({
    queryKey: queryKeys.departments,
    queryFn: async () => (await getAllDepartments()).data,
  }).data;

export const usePersons = (inactive: boolean) =>
  useSuspenseQuery({
    queryKey: queryKeys.persons(inactive),
    queryFn: async () =>
      (
        await getAllPersons({
          query: { inactive: inactive ? "true" : undefined },
        })
      ).data,
  }).data;

/**
 * Non-suspending Variante. Für Komponenten ohne eigene Suspense-Grenze bzw.
 * zustandsbehaftete Container (sonst würde ein Suspense State verwerfen).
 */
export const usePersonsAsync = (inactive: boolean) =>
  useQuery({
    queryKey: queryKeys.persons(inactive),
    queryFn: async () =>
      (
        await getAllPersons({
          query: { inactive: inactive ? "true" : undefined },
        })
      ).data,
  }).data ?? [];

export const useShoppingList = () =>
  useSuspenseQuery({
    queryKey: queryKeys.shoppingList,
    queryFn: async () => (await getShoppingList()).data,
  }).data;
